import { render, staticRenderFns } from "./BottomNavHub.vue?vue&type=template&id=a8c20b4c&scoped=true&"
import script from "./BottomNavHub.vue?vue&type=script&lang=js&"
export * from "./BottomNavHub.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavHub.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BottomNavHub.vue?vue&type=style&index=1&id=a8c20b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c20b4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBottomNavigation,VBtn,VContainer,VProgressCircular})
